/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { Typo } from 'src/components/common/ui';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';

const priceFontSize = {
  default: 'cpds-heading-roman-med-05',
  fixture: 'cpds-body-roman-medium-08',
};

export const V3ProductCardPrice = styled(Typo.HTMLText).attrs(({ size }) => ({
  tag: 'h5',
  exClass: `${checkValue(priceFontSize?.[size]) ? priceFontSize?.[size] : 'cpds-heading-roman-med-05'}`,
}))<{ color?: string; size?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${checkValue(color) ? color : token?.v3_product_card_price_text_color};
    `;
  }}
`;

export const V3ProuctCardPriceContainer = styled.div.attrs({
  'data-cy': 'productCardPriceContainer',
  className: 'product-card-price-container',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      flex-direction: column;
      gap: 2px;
      margin-top: ${token?.spacing?.space_8};
    `;
  }}
`;
